exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.new-hazard[data-v-7fcc7360] {\n    position: absolute;\n    top: 0;\n    right: -28px;\n    height: 38px;\n}\n", ""]);

// exports
